<template>
    <div class="editor-content mb-5">
        <quill-editor ref="textEditor" :content="note"  :options="editorOption" @change="onEditorChange($event)" class="editor">
            <div class="output ql-snow" >
                <div class="ql-editor" v-html="note"></div>
            </div>
        </quill-editor>
        <input :id="attribute" :name="attribute" type="hidden" v-model="note">
    </div>
</template>

<script>

import { quillEditor } from 'vue-quill-editor';
import debounce from 'lodash/debounce';
import MagicUrl from 'quill-magic-url';
import Quill from 'quill'


// import theme style
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

Quill.register('modules/clink', (quill) => {
    let currentLink = null;
    quill.container.addEventListener('mouseover', (evt) => {
        if (evt.target.tagName === 'A') {
            currentLink = evt.target;
            currentLink.setAttribute('contenteditable', false);
        } else if (currentLink) {
            currentLink.removeAttribute('contenteditable');
            currentLink = null;
        }
    });
});
Quill.register('modules/magicUrl', MagicUrl)

const SizeStyle = Quill.import('attributors/style/size');
SizeStyle.whitelist = ['8pt', '9pt', '11pt', '14pt'];
Quill.register(SizeStyle, true);

export default {
    name: "CustomEditor",
    components: {quillEditor},
    props: {
        content : String,
        property: String,
        simple: {
            type: Boolean,
            default: false,
        },
    },
    data(){
        const fullToolbar = [
            [{ 'header':
                [1, 2, 3, false],
             }],
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'align': [] }, { 'color': [] }, { 'background': [] }],
            ['link', 'clean']

        ];
        const simpleToolbar = [
            [{ 'size': ['8pt', '9pt', false, '11pt', '14pt'] }],
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['clean'],
        ];
        const modules = {
            toolbar: this.simple ? simpleToolbar : fullToolbar,
        };
        if (!this.simple) {
            modules.clink = true;
            modules.magicUrl = true;
        }
        return {
            note : this.content,
            attribute: this.property ? this.property : 'content',
            editorOption: {
                theme: 'snow',
                placeholder: "Saisir le contenu ..",
                modules: modules,
            },
        }
    },
    methods: {
         onEditorChange: debounce(function(value) {
             if(this.note != value.html){
                this.note = value.html;
            }
         }),
    }
}
</script>

<style>
.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item::before { content: "10,5 pt"; }
.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item:not([data-value])::before { font-size: 14px; }

.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="8pt"]::before,
.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="8pt"]::before { content: "8 pt"; }
.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="9pt"]::before,
.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="9pt"]::before { content: "9 pt"; }
.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="11pt"]::before,
.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="11pt"]::before { content: "11 pt"; }
.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14pt"]::before,
.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14pt"]::before { content: "14 pt"; }

.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="8pt"]::before  { font-size: 8pt; }
.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="9pt"]::before  { font-size: 9pt; }
.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="11pt"]::before { font-size: 11pt; }
.ql-toolbar.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14pt"]::before { font-size: 14pt; }
</style>
